export const ORDER_PENDING = "order/ORDER_PENDING";
export const ORDER_FULFILLED = "order/ORDER_FULFILLED";